module.exports = __webpack_public_path__ + "img/contest_main_title.3bc9f6e1.png";